import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { TicketApiModel } from '../model/api-model/shared/ticket/ticket.api.model';
import { Cacheable, LocalStorageStrategy } from 'ts-cacheable';

@Injectable({
  providedIn: 'root'
})
export class OrderTicketHttpService {
  public static cacheBuster$ = new Subject<void>();

  constructor(private http: HttpClient) {}

  @Cacheable({
    storageStrategy: LocalStorageStrategy,
    cacheBusterObserver: OrderTicketHttpService.cacheBuster$,
    maxAge: 1000,
    shouldCacheDecider: (response) => {
      return Array.isArray(response) && response !== null && response.length > 0;
    }
  })
  getOrderTickets(cinemaId: string, orderId: string): Observable<TicketApiModel[]> {
    return this.http.get<TicketApiModel[]>(`/cinema/${cinemaId}/order/${orderId}/tickets`);
  }
}
